import { useAuth } from "../contexts/AuthContext";

export type DataplorApiErrorItem_T = {
  status: string;
  code: string;
  message: string;
};

export type DataplorApiError_T = Error & {
  status?: number;
  error?: string;
  errors?: DataplorApiErrorItem_T[];
};

export const useDataPlorApi = () => {
  const { authAttributes } = useAuth();
  const baseUrl = process.env.REACT_APP_PROD_API_URL;
  const postDataplorApi = async (endpoint: string, body: unknown) => {
    const response = await fetch(`${baseUrl}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${authAttributes?.token}, email="${authAttributes?.email}"`,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errorData = await response.json();
      const error = new Error(
        errorData.error || `HTTP error! status: ${response.status}`
      ) as DataplorApiError_T;
      error.status = response.status;
      error.error = errorData.error;
      error.errors = errorData.errors;
      throw error;
    }

    return response;
  };

  return { postDataplorApi };
};
